import { render, staticRenderFns } from "./ListaHorariosAprazamento.vue?vue&type=template&id=51ed28ea&"
import script from "./ListaHorariosAprazamento.vue?vue&type=script&lang=js&"
export * from "./ListaHorariosAprazamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports